import React from 'react'
import { Link } from "react-router-dom"
import path from '../../Assets/path-image.svg'
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from 'react';

const pathItems = [
	{
		icon: 'ri-heart-line',
		title: 'Spiritual Values',
		text: 'Cultivating spiritual values alongside academic excellence for holistic growth.',
	},
	{
		icon: 'ri-code-s-slash-line',
		title: 'Coding & Critical Thinking',
		text: 'Developing future-ready skills from coding to analytical and critical thinking.',
	},
	{
		icon: 'ri-microscope-line',
		title: 'Science & Technology',
		text: 'Preparing girls to lead and innovate in science and technology.',
	},
	{
		icon: 'ri-earth-line',
		title: 'National Contribution',
		text: 'Fostering moral development and nurturing leaders who contribute to the nation.',
	},
];

const Path = () => {

	useEffect(() => {
		AOS.init({ disable: "phone", duration: 700 });
	}, []);

	return (
		<div className="path-section">
			<div className="container-main">
				<div className="path-top-label" data-aos="fade-up">
					<span className="path-pill">Start Your Path</span>
					<h1 className="path-main-heading montserrat">
						Various Learning Paths To
						<span className="path-main-block-text montserrat"> Achieve Success</span>
					</h1>
				</div>

				<div className="row align-items-center">
					<div className="col-lg-6" data-aos="fade-right">
						<div className="path-image-wrap">
							<img src={path} className="path-image-main" alt="" />
							<div className="path-image-badge">
								<i className="ri-star-fill"></i>
								<span>Excellence in Education</span>
							</div>
						</div>
					</div>

					<div className="col-lg-6" data-aos="fade-left">
						<div className="path-content">
							<h2 className="montserrat path-sub-main-heading">
								Limitless Learning,
								<span className="path-block-text montserrat"> Limitless Possibilities!</span>
							</h2>
							<p className="path-small">
								Éloria stands as the fulfilment of the dream of a skilled young generation who can contribute to national resources and boost moral development. With diverse learning paths and limitless possibilities, Éloria offers an inspiring environment where potential is realised and success becomes achievable.
							</p>

							<div className="path-feature-grid">
								{pathItems.map((item, i) => (
									<div className="path-feature-card" key={i} data-aos="fade-up" data-aos-delay={i * 80}>
										<div className="path-feature-icon">
											<i className={item.icon}></i>
										</div>
										<div>
											<h6 className="path-feature-title">{item.title}</h6>
											<p className="path-feature-text">{item.text}</p>
										</div>
									</div>
								))}
							</div>

							<Link className="btn explore-btn-about mt-3" to="/">Explore Now</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Path
